import { DISMISS_STATE_KIND } from './DISMISS_STATE_KIND';
import type { DismissState } from './DismissState';

export const createDismissedState = (
	firstViewedAt: number,
	dismissedAt: number,
	sourcesClickedAt?: number,
): DismissState => ({
	kind: DISMISS_STATE_KIND.DISMISSED,
	firstViewedAt,
	sourcesClickedAt,
	dismissedAt,
});
